
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18","data-token-name":"eid"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.769 4.078H5.307c-.68 0-1.23.551-1.23 1.23V7.77c0 .68.55 1.231 1.23 1.231H7.77c.68 0 1.23-.551 1.23-1.23V5.308c0-.68-.55-1.23-1.23-1.23zM4.077 1H2.23A1.23 1.23 0 001 2.23v1.847M13.923 1h1.846a1.23 1.23 0 011.23 1.23v1.847M4.077 16.999H2.23A1.23 1.23 0 011 15.768v-1.846m12.923 3.077h1.846a1.23 1.23 0 001.23-1.231v-1.846M4.077 12.078v1.846h1.846m3.077 0v-1.846H7.154m6.769-6.154h-1.846V4.078m1.846 6.143V8.375h-1.846m0 3.703v1.846h1.846","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    